import { render, staticRenderFns } from "./TopTerms.vue?vue&type=template&id=16498c92&scoped=true&"
import script from "./TopTerms.vue?vue&type=script&lang=js&"
export * from "./TopTerms.vue?vue&type=script&lang=js&"
import style0 from "./TopTerms.vue?vue&type=style&index=0&id=16498c92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16498c92",
  null
  
)

export default component.exports